import React from "react";
import {
  Box,
  TextField,
  IconButton,
  CircularProgress,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import DeleteOutlineTwoToneIcon from "@mui/icons-material/DeleteOutlineTwoTone";

export const AddTaskForm = ({ 
  newTask, 
  setNewTask, 
  onCancel, 
  onSubmit, 
  loading 
}) => {
  return (
    <Box sx={{ mb: 1, p: 1, borderRadius: "4px" }}>
      <TextField
        fullWidth
        margin="dense"
        name="text"
        label="תקציר המשימה"
        type="text"
        multiline
        rows={4}
        value={newTask.text}
        onChange={(e) => setNewTask({ ...newTask, text: e.target.value })}
        sx={{ mb: 2 }}
      />
      {/* delete icon */}
      <IconButton
        color="warning"
        aria-label="delete user"
        onClick={onCancel}
      >
        <DeleteOutlineTwoToneIcon />
      </IconButton>
      {/* send icon */}
      {loading ? (
        <CircularProgress style={{ marginTop: 16 }} />
      ) : (
        <IconButton
          color="success"
          aria-label="send message"
          onClick={onSubmit}
        >
          <SendIcon />
        </IconButton>
      )}
    </Box>
  );
};